import { formatoPatente } from "../../shared/unidad";

/* La patente dibujada como CHAPA MERCOSUR: el rectángulo blanco con la franja
 * azul arriba y las letras en negro, `AF 021 BB`.
 *
 * Lo pidió Igna con una captura y quedó escrito por qué: «quedan re facheras»
 * (03/10). Pero además sirve: en una pantalla con internos, legajos, números
 * de viaje y de póliza —todos en la misma monoespaciada— la patente era un
 * código más entre otros. Con la forma de la chapa se reconoce sin leerla, que
 * es como la reconoce el que la mira en el portón.
 *
 * ── ES UNA PIEZA APARTE Y NO UN `.plate-chip` RETOCADO ───────────────────
 *
 * `.plate-chip` se usa también para internos, números de viaje y la lona del
 * furgón. Pintarlo de chapa convertiría al «774» y al viaje «1203» en
 * patentes que no existen. Acá entra SÓLO un dominio.
 *
 * ── SIN DOMINIO NO SE DIBUJA NADA ────────────────────────────────────────
 *
 * Una chapa en blanco se lee como «la patente es esta, vacía». Que no haya
 * patente lo dice cada pantalla con sus palabras —«sin patente cargada», un
 * guion en la tabla—, porque sólo ella sabe por qué falta.
 *
 * `grande` es la de la cabeza de la ficha de la unidad; sin él, la de tabla,
 * que entra en un renglón sin hacerlo más alto. */
const Patente = ({ dominio, grande = false, className = "" }) => {
  const texto = formatoPatente(dominio);
  if (!texto) return null;
  const clases = ["patente-mer", grande ? "patente-mer--grande" : "", className]
    .filter(Boolean)
    .join(" ");
  return (
    /* `role="img"` porque es un dibujo de una chapa y el nombre lo dice
     * entero: un lector de pantalla lee «Patente AF 021 BB» y no tres
     * pedazos sueltos. El `title` es lo mismo para el que pasa el mouse. */
    <span
      className={clases}
      role="img"
      aria-label={`Patente ${texto}`}
      title={`Patente ${texto}`}
    >
      {texto}
    </span>
  );
};

export default Patente;
